module.exports = __webpack_public_path__ + "img/tcac.26db8274.png";